/*@flow*/
import * as I from 'immutable';

export const categoryColorDomain = [
  'Noise',
  'Illegal Parking',
  'Noise - Residential',
  'Street Condition',
  'Street Light Condition',
  'Water System',
  'Taxi Complaint',
  'Traffic Signal Condition',
  'Consumer Complaint',
  'For Hire Vehicle Complaint',
  'Sewer',
  'Vending',
  'Noise - Street/Sidewalk',
  'Dirty Conditions',
  'Sanitation Condition',
  'Noise - Commercial',
  'Broken Muni Meter',
  'Sidewalk Condition',
  'General Construction/Plumbing',
  'Homeless Person Assistance',
];

export const categoryColorRange = [
  '#4c78a8',
  '#9ecae9',
  '#f58518',
  '#ffbf79',
  '#54a24b',
  '#88d27a',
  '#b79a20',
  '#f2cf5b',
  '#439894',
  '#83bcb6',
  '#e45756',
  '#ff9d98',
  '#79706e',
  '#bab0ac',
  '#d67195',
  '#fcbfd2',
  '#b279a2',
  '#d6a5c9',
  '#9e765f',
  '#d8b5a5',
];

export const zippedColors = I.fromJS(categoryColorDomain)
  .zip(I.fromJS(categoryColorRange))
  .toJS()
  .reduce((s, v) => s.concat(v), []);
